export default __webpack_public_path__ + "static/2185-d433ca325d7cc05f885d7f03a83e2d0a.gif";